import {FetchService} from "../../node_modules/cronus-theme/default/global/ts/fetch.service";

/**
 * Übersicht "Geteilte Kollektionslinks".
 * Lädt die Liste per AJAX (/em/collectionShare/list), rendert Tabelle + Filter
 * (Typ, Suche) und zeigt Details in einem selbstständigen Modal.
 * Aktiviert sich nur, wenn der Seiten-Container vorhanden ist.
 */
export function initSharedLinks() {
    const root = document.querySelector('.js-sharedLinks');
    if (!root) return;

    const typeSelect = root.querySelector('.js-sharedLinksType');
    const searchInput = root.querySelector('.js-sharedLinksSearch');
    const tbody = root.querySelector('.js-sharedLinksBody');
    const stateEl = root.querySelector('.js-sharedLinksState');
    const detail = root.querySelector('.js-sharedLinksDetail');

    let debounceTimer = null;

    async function load() {
        stateEl.textContent = 'Wird geladen …';
        tbody.innerHTML = '';

        const params = new URLSearchParams();
        if (typeSelect.value !== '') params.set('type', typeSelect.value);
        const search = searchInput.value.trim();
        if (search !== '') params.set('search', search);

        try {
            const query = params.toString();
            const response = await FetchService.get('/em/collectionShare/list' + (query ? '?' + query : ''));
            if (!response || !response.success) {
                stateEl.textContent = 'Fehler beim Laden der Links.';
                return;
            }
            render(response.links || []);
        } catch (err) {
            stateEl.textContent = 'Fehler beim Laden der Links.';
        }
    }

    function render(links) {
        tbody.innerHTML = '';
        stateEl.textContent = links.length ? '' : 'Keine Einträge gefunden.';

        links.forEach(function (link) {
            const tr = document.createElement('tr');
            tr.innerHTML =
                '<td>' + link.collectionId + '</td>' +
                '<td class="is-link">' + escapeHtml(link.shareLink) + '</td>' +
                '<td>' + daysBadge(link.daysRemaining) + '</td>';
            tr.addEventListener('click', function () { openDetail(link); });
            tbody.appendChild(tr);
        });
    }

    function openDetail(link) {
        detail.querySelector('.js-sdName').textContent = link.collectionName || ('Kollektion #' + link.collectionId);
        detail.querySelector('.js-sdLink').textContent = link.shareLink;
        detail.querySelector('.js-sdCreated').textContent = formatDate(link.createdAt);
        detail.querySelector('.js-sdValid').textContent = formatDate(link.validUntil);

        const typeEl = detail.querySelector('.js-sdType');
        typeEl.textContent = link.type === 1 ? 'Langzeit (300 Tage)' : 'Standard (7 Tage)';

        const daysEl = detail.querySelector('.js-sdDays');
        daysEl.textContent = formatDays(link.daysRemaining);
        daysEl.classList.toggle('is-valid', link.daysRemaining > 0);
        daysEl.classList.toggle('is-expired', link.daysRemaining <= 0);

        const copyBtn = detail.querySelector('.js-sdCopy');
        const copyLabel = copyBtn.querySelector('span');
        const originalLabel = copyLabel ? copyLabel.textContent : '';
        copyBtn.onclick = function () {
            copyToClipboard(link.shareLink).then(function () {
                if (copyLabel) {
                    copyLabel.textContent = 'Kopiert!';
                    setTimeout(function () { copyLabel.textContent = originalLabel; }, 1500);
                }
            });
        };

        detail.style.display = 'flex';
    }

    function closeDetail() {
        detail.style.display = 'none';
    }

    // Sicherstellen, dass das Modal initial geschlossen ist.
    closeDetail();

    root.querySelectorAll('.js-sharedLinksDetailClose').forEach(function (el) {
        el.addEventListener('click', closeDetail);
    });
    document.addEventListener('keydown', function (e) {
        if (e.key === 'Escape' && detail.style.display !== 'none') closeDetail();
    });

    typeSelect.addEventListener('change', load);
    searchInput.addEventListener('input', function () {
        clearTimeout(debounceTimer);
        debounceTimer = setTimeout(load, 300);
    });

    load();
}

function copyToClipboard(text) {
    if (navigator.clipboard && navigator.clipboard.writeText) {
        return navigator.clipboard.writeText(text);
    }
    // Fallback für ältere Browser
    return new Promise(function (resolve) {
        const ta = document.createElement('textarea');
        ta.value = text;
        ta.style.position = 'fixed';
        ta.style.opacity = '0';
        document.body.appendChild(ta);
        ta.select();
        try { document.execCommand('copy'); } catch (e) {}
        document.body.removeChild(ta);
        resolve();
    });
}

function formatDays(days) {
    return days + (days === 1 ? ' Tag' : ' Tage');
}

function daysBadge(days) {
    const cls = days > 0 ? 'is-valid' : 'is-expired';
    return '<span class="sharedLinks__badge ' + cls + '">' + formatDays(days) + '</span>';
}

function formatDate(value) {
    if (!value) return '';
    const d = new Date(String(value).replace(' ', 'T'));
    if (isNaN(d.getTime())) return value;
    return d.toLocaleDateString('de-DE', {
        day: '2-digit', month: '2-digit', year: 'numeric',
        hour: '2-digit', minute: '2-digit'
    });
}

function escapeHtml(value) {
    return String(value).replace(/[&<>"']/g, function (c) {
        return {'&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;'}[c];
    });
}
